import { CommonService } from '@business/services';
import { Endpoint } from '../endpoint';
import {
  EstimateGroupLineItemData,
  EstimateItemFormData,
  EstimateItemGroupData,
} from '@modules/organizations/OrganizationPage/Components/Design/EstimateForm';
import {
  EstimateSearchParams,
  TMEstimateId,
  TMEstimateResponse,
  CompactTMEstimateResponse,
  TMEstimateGroupId,
  TMEstimateLineItemResponse,
  VeryCompactTMEstimateResponse,
  TMEstimateLineItemId,
} from '@business/entities/tm';
import { AddEstimateFormData } from '@modules/organizations/OrganizationPage/Components/Design/AddEstimateModal/AddEstimateModal';
import { R } from '@core/utils/r';
import { OrgId } from '@business/entities/organization';
import { CategoryOptionId } from '@business/entities/category_option';
import { ServiceProviderId } from '@business/entities/tm/TmServiceProviderResponse';
import { EstimatorTemplateType } from '@business/entities/tm/TmTemplateEstimatorResponse';

export function fetchEstimates(orgId?: OrgId, isCompact = false) {
  const params = R.objectCompact({ orgId, isCompact });
  // if(isCompact){
  //   return Endpoint.get<CompactTMEstimateResponse[]>(`@gc/estimates`, { params });
  // }
  return Endpoint.get<TMEstimateResponse[]>(`@gc/estimates`, { params });
}

export function fetchEstimatesPaginated(params: EstimateSearchParams) {
  return Endpoint.get<CompactTMEstimateResponse[]>(`@gc/estimates/estimates-paginated`, { params: R.objectCompact(params) });
}

export function fetchEstimate(id: TMEstimateId) {
  return Endpoint.get<TMEstimateResponse>(`@gc/estimates/estimate/${id}`);
}

export function createEstimate(data: AddEstimateFormData) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<TMEstimateResponse>(`@gc/estimates`, { formData, hasFiles: true });
}

export function recalculateEstimate(id: TMEstimateId) {
  return Endpoint.post<TMEstimateResponse>(`@gc/estimates/recalculate/${id}`);
}

export function updateEstimate(id: TMEstimateId, data: EstimateItemFormData) {
  return Endpoint.patch<TMEstimateResponse>(`@gc/estimates/${id}`, { data });
}

export function deleteEstimate(id: TMEstimateId) {
  return Endpoint.delete<void>(`@gc/estimates/${id}`);
}

export function addOrUpdateGroup(id: TMEstimateId, data: EstimateItemGroupData) {
  return Endpoint.post<TMEstimateResponse>(`@gc/estimates/group/${id}`, { data });
}

export function updateWeProvide(groupId: TMEstimateGroupId, item: EstimateGroupLineItemData) {
  const data = R.objectCompact({ ...item, groupId });
  return Endpoint.post<TMEstimateLineItemResponse>(`@gc/estimates/update-item`, { data });
}

export function qtyUpdate(groupId: TMEstimateGroupId, item: EstimateGroupLineItemData) {
  const data = R.objectCompact({ ...item, groupId });
  return Endpoint.post<TMEstimateResponse>(`@gc/estimates/qty-update-item`, { data });
}

export function getEstimateTitle(orgId: OrgId, type: EstimatorTemplateType) {
  return Endpoint.get<{ title: string }>(`@gc/estimates/title/${orgId}`, { params: { type } });
}

export function fetchSubProjects(orgId: OrgId) {
  return Endpoint.get<VeryCompactTMEstimateResponse[]>(`@gc/estimates/sub-projects/${orgId}`);
}

export function updateOption(groupId: TMEstimateGroupId, optionId: CategoryOptionId, providerId: ServiceProviderId) {
  const data = R.objectCompact({ optionId, providerId });
  return Endpoint.post<TMEstimateResponse>(`@gc/estimates/update-option/${groupId}`, { data });
}

export function updateNote(itemId: TMEstimateLineItemId, note: string) {
  const data = { note };
  return Endpoint.patch<void>(`@gc/estimates/update-note/${itemId}`, { data });
}
